import { isChrome, browserVersion } from "react-device-detect";
const DetectBrowser = (openLock) => {
  if (isChrome && parseInt(browserVersion) > 89) openLock();
};
export default DetectBrowser;
